import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { between, from, headlineBold24, palette, space, } from '@guardian/source/foundations';
import { SvgInfoRound } from '@guardian/source/react-components';
import FlexContainer from 'components/containers/flexContainer';
import ProductInfoChip from 'components/product/productInfoChip';
import ProductOption from 'components/product/productOption';
import { Collection, HomeDelivery, } from 'helpers/productPrice/fulfilmentOptions';
import LinkTo from './linkTo';
const pricesSection = css `
	padding: 0 ${space[3]}px ${space[12]}px;
`;
const pricesHeadline = css `
	${headlineBold24};
	${from.tablet} {
		font-size: 34px;
	}
`;
const priceBoxes = css `
	margin-top: ${space[6]}px;
	justify-content: flex-start;
	${from.tablet} {
		margin-top: 56px;
	}
`;
const productOverride = css `
	&:not(:first-of-type) {
		margin-top: ${space[4]}px;
	}
	${from.tablet} {
		&:not(:first-of-type) {
			margin-top: 0;
		}
		&:not(:last-of-type) {
			margin-right: ${space[4]}px;
		}
	}
	${between.tablet.and.desktop} {
		padding: ${space[3]}px ${space[2]}px;
	}
	${from.desktop} {
		&:not(:last-of-type) {
			margin-right: ${space[5]}px;
		}
	}
`;
const productOverrideWithLabel = css `
	${productOverride}
	&:not(:first-of-type) {
		margin-top: ${space[12]}px;
	}
	${from.tablet} {
		&:not(:first-of-type) {
			margin-top: 0;
		}
	}
`;
const pricesInfo = css `
	margin-top: ${space[6]}px;
`;
const pricesTabs = css `
	margin-bottom: 13px;
	display: flex;
	border-bottom: 1px solid ${palette.brand[600]};
`;
export function PaperPrices({ activeTab, setTabAction, products, }) {
    const infoText = `${activeTab === HomeDelivery ? 'Delivery is included. ' : ''}You can cancel your subscription at any time`;
    return (_jsxs("section", { css: pricesSection, children: [_jsx("h2", { css: pricesHeadline, children: "Pick your subscription package below" }), _jsxs("div", { css: pricesTabs, children: [_jsx(LinkTo, { tab: HomeDelivery, setTabAction: setTabAction, activeTab: activeTab, isPricesTabLink: true, children: "Home Delivery" }), _jsx(LinkTo, { tab: Collection, setTabAction: setTabAction, activeTab: activeTab, isPricesTabLink: true, children: "Subscription card" })] }), _jsx(FlexContainer, { cssOverrides: priceBoxes, children: products.map((product) => (_jsx(ProductOption, { cssOverrides: product.label ? productOverrideWithLabel : productOverride, title: product.title, price: product.price, priceCopy: product.priceCopy, offerCopy: product.offerCopy, buttonCopy: product.buttonCopy, href: product.href, onClick: product.onClick, onView: product.onView, label: product.label, unavailableOutsideLondon: product.unavailableOutsideLondon }))) }), _jsx("div", { css: pricesInfo, children: _jsx(ProductInfoChip, { icon: _jsx(SvgInfoRound, {}), children: infoText }) })] }));
}
